
// import React from 'react'
// import ReactDOM from "react-dom/client";

// import { App } from "./App";
// import { ViewDocument, PartnerReport } from './components';

// const root = ReactDOM.createRoot(document.getElementById("root"));

// root.render(
//   <React.StrictMode>
//   <ViewDocument />
//   </React.StrictMode>
// );

//https://react-pdf-viewer.dev/docs/basic-usage/
import packageJSON from '../../../package.json';
export const pdfjsVersion = () => {
  return packageJSON.dependencies["pdfjs-dist"];
};


export {
  TestAnt,
  ViewDocument,
  EventsReport,
  PartnerReport,
  NYSReport,
  STEMIOlympiadReport,
  ActivityIndicator,
  AddressControl,
  CheckboxSwitchery,
  ContactField,
  FileCard,
  GenericChart,
  GenericGeoMap,
  InvalidPage,
  Offline,
  ProgressControl,
  ProgressPercControl,
  ReportButtons,
  ReportTemplate,
  RichTextEditor,
  SearchControl,
  openNotification,
  FormItemList,
  ParagraphHeader,
  CitizenScienceReport,
  EventsGeographicReport,
  FileGeneratorProgress,
  reportTypeEnum,
  contribEnum,
  docsEnum,
  genEnum,
  defaultSettingEnum,
  localityEnum,
  paginationEnum,
  progressIndicatorEnum,
  fieldValidity,
  booleanEnum,
  citizenScienceStatusEnum,
  citizenScienceStatusContribEnum,
  csParticipRoleEnum,
} from "./components";